export async function getData(endpoint, options = {}) {
    const {
        appUser = null,
        token = null,
        logout = null
    } = options;

    const url = `${process.env.REACT_APP_API_BASE_URL}/${endpoint}`;

    const res = await fetch(url, {
        headers: await prepareHeaders(appUser, token),
    });

    // Auto-logout if the token is expired/invalid (401 Unauthorized)
    if (logout && res.status === 401) {
        logout();
    }

    return await handleResponse(res);
}

export async function getAuthData(endpoint, appUser, token, logout) {
    return await getData(endpoint, { appUser: appUser, token: token, logout: logout });
}

export async function postData(endpoint, data, options = {}) {
    const {
        appUser = null,
        token = null,
        logout = null
    } = options;

    const url = `${process.env.REACT_APP_API_BASE_URL}/${endpoint}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: await prepareHeaders(appUser, token),
        body: JSON.stringify(data),
    });

    // Auto-logout if the token is expired/invalid (401 Unauthorized)
    if (logout && res.status === 401) {
        logout();
        window.location.href = '/inloggen';
    }

    return await handleResponse(res);
}

export async function postAuthData(endpoint, data, appUser, token, logout) {
    return await postData(endpoint, data, { appUser: appUser, token: token, logout: logout });
}

const prepareHeaders = async (appUser = null, token = null, contentType = "application/json") => {
    return {
        ...token && { "Authorization": `Bearer ${token}` },
        // "Accept": "application/json",
        ...(contentType && { "Content-Type": contentType }),
        ...(appUser && { "App-User": appUser })
    };
}

const handleResponse = async (response) => {
    // Parse response body
    const responseText = await response.text().catch(() => "");
    let responseData = null;

    if (responseText) {
        try {
            responseData = JSON.parse(responseText);
        } catch {
            responseData = { raw: responseText };
        }
    }

    if (!response.ok) {
        return {
            error: {
                status: response.status,
                message: responseData?.error || "Er ging iets mis"
            }
        }
    }

    return responseData || null;
}